function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.977 7.536a.316.316 0 00-.065-.337l-3.623-3.708a.297.297 0 00-.427 0 .314.314 0 000 .437l3.108 3.181H8.453a.305.305 0 00-.302.31c0 .17.135.308.302.308h6.517l-3.108 3.182a.314.314 0 000 .437.298.298 0 00.427 0l3.623-3.709a.312.312 0 00.065-.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.566 8.964a.305.305 0 00-.302.309v4.945H7.246V2.473a.308.308 0 00-.21-.295L2.245.618h8.018v4.946c0 .17.135.309.302.309a.305.305 0 00.302-.31V.31a.306.306 0 00-.302-.309H.302C.292 0 .284.005.275.006a.158.158 0 00-.048.01.29.29 0 00-.078.033C.14.054.132.054.124.059.114.066.107.075.1.083L.084.098a.322.322 0 00-.056.084L.021.201a.315.315 0 00-.02.108v14.218c0 .039.008.075.021.11.004.011.01.021.016.032a.298.298 0 00.125.128.221.221 0 00.034.018l.014.007 6.642 2.164a.298.298 0 00.27-.045.311.311 0 00.123-.25v-1.855h3.32a.305.305 0 00.302-.309V9.273a.306.306 0 00-.302-.31zm-3.924 7.304L.604 14.301V.731L6.642 2.7v13.57z"
}));

var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/exit.dd91f078.svg";
export { SvgExit as ReactComponent };